import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

import Input from '@iso/components/uielements/input';
import Button from '@iso/components/uielements/button';
import IntlMessages from '@iso/components/utility/intlMessages';
import Loader from '@iso/components/utility/loader';
import notification from '@iso/components/Notification';
import ForgotPasswordStyleWrapper from './ForgotPassword.styles';

import apiAccount from '@iso/services/repository/account';

export default function() {
  const [regainAccess, setRegainAccess] = useState('');
  const [load, setLoad] = useState(false);

  let history = useHistory();

  const sendLink = () => {
    setLoad(true);
    console.log(regainAccess)

    apiAccount
      .sendEmail(regainAccess)
      .then((response) => {
        if(response.data.error || !response.data.status){
          notification('error', response.data.message);
        } else {
          notification('success', response.data.message);
          history.push('/');
        }
        setLoad(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }

  return (
    <ForgotPasswordStyleWrapper className="isoForgotPassPage">
      <div className='contentMyLogo'>&nbsp;</div>
      <div className="isoFormContentWrapper">
        <div className="isoFormContent">
          <div className="isoLogoWrapper">
            <Link to="/dashboard">
              <IntlMessages id="page.forgetPassTitle" />
            </Link>
          </div>

          <div className="isoFormHeadText">
            <h3>
              <IntlMessages id="page.forgetPassSubTitle" />
            </h3>
            <p>
              <IntlMessages id="page.forgetPassDescription" />
            </p>
          </div>

          <div className="isoForgotPassForm">
            <div className="isoInputWrapper">
              <Input
                size="large"
                placeholder="Login"
                value={regainAccess}
                name="domain"
                onChange={(e) => setRegainAccess(e.target.value) }
                className="BillFormTitle"
              />
            </div>

            { load ? (
              <Loader />
            ) : (
              <div>

                <div className="isoInputWrapper">
                  <Button type="primary" onClick={sendLink}>
                    <IntlMessages id="page.sendRequest" />
                  </Button>
                </div>
                <div className="isoInputWrapper">
                  <Button>
                    <Link to="/login">
                      <IntlMessages id="page.cancel" />
                    </Link>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ForgotPasswordStyleWrapper>
  );
}
